
<div id="app">
	<link
		rel="stylesheet"
		href="https://use.fontawesome.com/releases/v5.2.0/css/all.css"
		crossorigin="anonymous"
	/>
	<Navbar />
	<router-view />
</div>
